import { memoPathDetected } from '../../tppServices/cacheService';
import { getBoatConstantsFromI18n } from '../../tppServices/translations/constants';
import { getFormatMessageFunction } from '../../tppServices/tppDi';
import { getMessages } from '../../tppServices/translations/messages';
import { definedValue } from '../index';

const getBasePathRegex = (fullPath) => {
  const index = fullPath.indexOf('/:');
  const basePath = index !== -1 ? fullPath.slice(0, index) : fullPath;
  return new RegExp(`^${basePath}`);
};
const detectBaseSearchPattern = (url, patterns) => {
  // add more search patterns here if needed
  const searchPatterns = [
    patterns.SEARCH_URL_PATTERN,
    patterns.MOORINGS_SEARCH_URL_PATTERN
  ];
  return searchPatterns.find((pattern) => {
    const re = getBasePathRegex(pattern);
    return re?.test(url);
  });
};

const detectBrandedSearchPattern = (url, patterns, i18Service) => {
  const t = getFormatMessageFunction(i18Service);
  const messages = getMessages();
  const { DEALER_GALLERY_URL_PATTERN, BRANDED_SEARCH_URL_PATTERN } = patterns;
  const dealerStr = t(messages.dealerPrefix);
  const clearedPattern = DEALER_GALLERY_URL_PATTERN.replace(
    /:owner.+/,
    `${dealerStr}-`
  );
  const re = new RegExp(clearedPattern);
  return re.test(url) ? DEALER_GALLERY_URL_PATTERN : BRANDED_SEARCH_URL_PATTERN;
};

const getSearchUrlPattern = (url, isBranded, i18Service) => {
  const prefix = isBranded ? 'branded' : null;
  let detected = memoPathDetected(url, null, prefix);
  if (detected) {
    return detected;
  }
  const patterns = getBoatConstantsFromI18n(i18Service);
  detected = !isBranded
    ? detectBaseSearchPattern(url, patterns)
    : detectBrandedSearchPattern(url, patterns, i18Service);
  memoPathDetected(url, detected, prefix);
  return detected;
};

const getDealerGalleryPattern = (cfg, bt, owner, dealerStr) => {
  const re = new RegExp(`${dealerStr}-(.*)`);
  const dealerPrefix = re.test(owner);
  // Using broker in URL with all style urls not to break YW
  const broker = definedValue(cfg?.supports?.useBrokerUrlPrefix, false);
  const dealerInRoot = broker || !dealerPrefix;
  const searchPattern = dealerInRoot
    ? bt.GENERATE_BRANDED_SEARCH_URL_PATTERN
    : bt.GENERATE_DEALER_GALLERY_URL_PATTERN;
  return searchPattern;
};

export {
  getSearchUrlPattern,
  getDealerGalleryPattern,
  detectBaseSearchPattern,
  detectBrandedSearchPattern,
  getBasePathRegex
};
